
      import Ask from './ask.vue'
      import type { App, Plugin } from 'vue'

      export const AskPlugin: Plugin = {
        install(app: App) {
          app.component('Ask', Ask)
        },
      }
      export { Ask }
      